import React from "react"
import {Grid} from "@material-ui/core"
import Layout from "../components/layout"
import SectionOne from '../sections/sectionone'
import SectionThree from "../sections/sectionthree";

const Homepage = (props) => {
  return (
      <Layout>
          <SectionOne/>
          <SectionThree/>
      </Layout>
  );
};

export default Homepage
